var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgRoof = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M19 13v6.018c0 1.067-1.089 1.946-2.411 1.946L8.41 21C7.09 21 6 20.121 6 19.054v-6.018",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeDasharray: "0.5 3"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m4 9.301 6.782-6.595c.972-.941 2.564-.941 3.525 0L21.09 9.3",
  stroke: "currentColor",
  strokeWidth: 2.25,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export { SvgRoof as Component };